import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>© 2024 TruckSiteFinder. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
